<template>
  <div class="about">
    <h1>Error 404 Page Not Found</h1>
  </div>
</template>
<script>
import { defineComponent } from '@vue/composition-api'

export default defineComponent({
  name: 'Error404View'
})
</script>
